<div class="featuredCard">
    <a [routerLink]="['/movies/', movie?.Dx]" routerLinkActive="router-link-active"  class="featuredImage" (mouseover)="onOver()" (mouseleave)="onOut()">
        <img [src]="movie?.Promo" alt="" >
        <video #videoRolloverEl *ngIf="movie?.videoBg && movie?.videoBg != ''" [src]="movie?.videoBg " [muted]="true"></video>
    </a>
    <!-- <div class="add">
        <mat-icon>add_2</mat-icon>
    </div> -->
    <app-add *ngIf="movie" [movie]="movie"></app-add>
    <div class="title" [innerHTML]="movie?.Title | safeHtml"></div>
    <div class="buttons">
        <div class="roundButton" (click)="onBookNow()">
            <div class="label">Book Now</div>
        </div>
        <a [routerLink]="['/movies/', movie?.Dx]" >
            <div class="roundButton">
                <div class="label">More Info</div>
            </div>
        </a>
        
    </div>
</div>
